<template>
<v-app
    id="login"    
    style="backgroundImage: url('/static/background.jpg'); background-repeat: no-repeat; background-size:cover; height:100%"
  >  
    <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg4>          
            <v-card 
              class="elevation-5 black"
              style=" top:0px; left:20px; width: 260px; 
                                transform-origin: left top; padding-left:30px; padding-right:30px;"
            >
              <span class="font-weight-bold white--text caption"
                >Solicitud de Cambio de Contraseña</span
              >
            </v-card>
          <v-card  v-if="!isValid" class="elevation-5 pa-4" >  
            <v-card-text>
              <div class="layout column align-center" >
                  <img
                    src="/static/logo_negro.png"
                    alt="proControl"
                    style="height:70px"
                  />
                  <h1 class="flex my-4 primary--text" ></h1>
              </div>              
              <br />
              <h1 class="title" >SOLICITUD NO VALIDA!!</h1>
              <br />
              <br />
              <v-alert :value="true" icon="info" color="info" >
                La solicitud a la que intenta acceder no es válida o ya caducó,
                intente generar una nueva o comuníquese con el administrador de
                ser necesario.
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small @click="loginurl" >
                  <v-icon color="secondary" >keyboard_arrow_left</v-icon> Ir a inicio</v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-if="isValid" class="elevation-5 pa-4" >
            <v-card-text>
              <div class="layout column align-center" >
                  <img
                    src="/static/logo_negro.png"
                    alt="proControl"
                    style="height:70px"
                  />
                  <h1 class="flex my-4 primary--text" ></h1>
              </div>              
              <v-form>
                <v-container grid-list-md text-xs-center @keyup.enter="actualizar()" >
                <v-text-field
                  :append-icon="iconpass"
                  name="pass_new"
                  :rules="[rules.required]"
                  label="Ingresar Nueva Contraseña"
                  :type="passwordFieldType"
                  @click:append="mostrarPass"
                  v-model="model.pass_new"
                ></v-text-field>
                <v-text-field
                  :append-icon="iconpass"
                  name="pass_confirm"
                  :rules="[rules.required]"
                  label="Confirmar Nueva Contraseña"
                  :type="passwordFieldType"
                  @click:append="mostrarPass"
                  v-model="model.pass_confirm"
                ></v-text-field>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                block small
                v-bind:disabled="model.pass_confirm === '' ||
                    model.pass_confirm != model.pass_new
                "
                @click="actualizar"
                :loading="loading"
                >Actualizar</v-btn
              >
            </v-card-actions>
          </v-card>
            </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>
    </v-content>
  
</v-app>
</template>

<script>
import axios from "axios";

export default {
  beforeMount: function() {
    this.validar();
  },
  /*beforeUpdate: function() {
    this.validar();
  },*/
  data: () => ({ fab: false,
    loading: false,
    passwordFieldType: "password",
    iconpass: "fa-eye",
    isValid: false,
    rules: {
      required: value => !!value || "El campo no puede ir vacio"
    },
    model: {
      pass_new: "",
      pass_confirm: ""
    }
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    computeLogo() {
      return "/static/logo_blanco.png";
    }
  },
  methods: {
    loginurl() {
      this.$router.push("/").catch(()=>{});
    },
    mostrarPass: function(evt) {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.iconpass =
        this.passwordFieldType === "password" ? "fa-eye" : "fa-eye-slash";
    },
    login() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      setTimeout(() => {
        this.$router.push("/dashboard").catch(()=>{});
      }, 1000);
    },
    validar() {
      var url =
        this.$hostname +
        "usuarios/" +
        this.$route.params.id +
        "/verifica_solicitud/";

      var self = this;
      axios
        .get(url)
        .then(function(response) {
          self.isValid = true;
        })
        .catch(function(error) {
          self.isValid = false;
          if (error.response.data.mensaje) {
            self.$swal({
              type: "error",
              title: "Operación No Valida",
              text: error.response.data.mensaje[0],
              footer: ""
            });
          }
        });
    },
    actualizar() {
      var data = {
        solicitud: this.$route.params.id,
        password: this.model.pass_new,
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache"
        }
      };

      var url = this.$hostname + "usuarios/completa_solicitud/";
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var self = this;
      axios
        .put(url, data)
        .then(function(response) {
          self.$router.push("/", () => { 
              self.$swal({
                type: "success",
                title: "Operación Existosa",
                text: response.data.mensaje,
                footer: ""
              });          
          }); 
        })
        .catch(function(error) {
          var msg =
            "No fue posible resetear la contraseña, intentenuevamente o comuníquese con el administrador";
          if (error.response.data.solicitud) {
            self.$swal({
              type: "error",
              title: "Operación No Valida",
              text: error.response.data.solicitud[0],
              footer: ""
            });
          } else {
            self.$swal({
              type: "error",
              title: "Datos no Válidos",
              text: msg,
              footer: ""
            });
          }
        }).then(()=>{
          this.$root.$dialogLoader.hide();          
        });
      // this.$router.push('/pass');
    }
  }
};
</script>
<style scoped lang="css" >
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
